import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { makeAPI } from '../services/api';

const Message = () => {
    const location = useLocation();

    const [action, setAction] = useState('');
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('Processing your request...');
    const [isResubscribing, setIsResubscribing] = useState(false);
    const [resubscribed, setResubscribed] = useState(false);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const actionParam = (query.get('action') || '').trim();
        const emailParam = (query.get('email') || '').trim();

        setAction(actionParam);
        setEmail(emailParam);
        setResubscribed(false);

        if (!actionParam || !emailParam) {
            setStatus('error');
            setMessage('This link is incomplete. You can continue exploring from home.');
            document.title = 'Message - CGES.CLUB';
            return;
        }

        if (actionParam === 'subscribe') {
            verifySubscribe(emailParam);
            return;
        }

        if (actionParam === 'unsubscribe') {
            verifyUnsubscribe(emailParam);
            return;
        }

        setStatus('error');
        setMessage('Invalid action in this link. You can continue exploring from home.');
        document.title = 'Message - CGES.CLUB';
    }, [location.search]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [status]);

    const verifySubscribe = async (mail) => {
        setStatus('loading');
        setMessage('Verifying your newsletter subscription...');
        document.title = 'Newsletter Subscription - CGES.CLUB';

        try {
            const verifyEmail = await makeAPI('/api/verify_newsletter', 'POST', false, { email: mail });
            if (verifyEmail?.status === 'S') {
                setStatus('success');
                setMessage(verifyEmail.message || 'Your subscription is now verified.');
                return;
            }

            setStatus('error');
            setMessage(verifyEmail?.message || 'We could not verify your subscription.');
        } catch (error) {
            setStatus('error');
            setMessage('Something went wrong while verifying your subscription.');
        }
    };

    const verifyUnsubscribe = async (mail) => {
        setStatus('loading');
        setMessage('Updating your newsletter preferences...');
        document.title = 'Newsletter Preferences - CGES.CLUB';

        try {
            const verifyEmail = await makeAPI('/api/unsubscribe_newsletter', 'POST', false, { email: mail });
            if (verifyEmail?.status === 'S') {
                setStatus('success');
                setMessage(verifyEmail.message || 'You have successfully unsubscribed from the newsletter.');
                return;
            }

            setStatus('error');
            setMessage(verifyEmail?.message || 'Unable to update your newsletter preference.');
        } catch (error) {
            setStatus('error');
            setMessage('Something went wrong while processing your request.');
        }
    };

    const handleResubscribe = async () => {
        if (!email || isResubscribing) {
            return;
        }

        setIsResubscribing(true);

        try {
            const subscribeResponse = await makeAPI('/api/subscribe_newsletter', 'POST', false, { subscribe_mail: email });
            if (subscribeResponse?.status === 'S') {
                setResubscribed(true);
                setStatus('success');
                setMessage(subscribeResponse.message || 'You are subscribed again. Welcome back!');
                return;
            }

            setStatus('error');
            setMessage(subscribeResponse?.message || 'Unable to re-subscribe right now. Please try again later.');
        } catch (error) {
            setStatus('error');
            setMessage('Something went wrong while re-subscribing. Please try again later.');
        } finally {
            setIsResubscribing(false);
        }
    };

    const heading = useMemo(() => {
        if (status === 'loading') return 'Just a moment...';
        if (status === 'error') return 'We hit a small snag';

        if (action === 'unsubscribe' && !resubscribed) {
            return 'You are unsubscribed';
        }

        if (action === 'unsubscribe' && resubscribed) {
            return 'Welcome back to the newsletter';
        }

        if (action === 'subscribe') {
            return 'Subscription confirmed';
        }

        return 'All set';
    }, [action, resubscribed, status]);

    const shouldShowResubscribe = action === 'unsubscribe' && status === 'success' && !resubscribed && Boolean(email);

    return (
        <section
            style={{
                // minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px 16px',
                //background:
                  //  'radial-gradient(circle at 12% 18%, rgba(255,129,14,0.22) 0%, rgba(255,129,14,0) 42%), radial-gradient(circle at 82% 16%, rgba(151,168,30,0.2) 0%, rgba(151,168,30,0) 40%), linear-gradient(170deg, #050505 0%, #0e0e0e 100%)',
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '720px',
                    borderRadius: '24px',
                    border: '1px solid rgba(255, 129, 14, 0.32)',
                    background: 'linear-gradient(160deg, rgba(27,27,27,0.96) 0%, rgba(18,18,18,0.95) 100%)',
                    boxShadow: '0 24px 60px rgba(0, 0, 0, 0.48)',
                    padding: '32px 28px',
                    textAlign: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '62px',
                        height: '62px',
                        margin: '0 auto 20px',
                        borderRadius: '50%',
                        display: 'grid',
                        placeItems: 'center',
                        fontSize: '24px',
                        border: status === 'error' ? '1px solid rgba(255, 116, 116, 0.35)' : '1px solid rgba(151, 168, 30, 0.35)',
                        background: status === 'error' ? 'rgba(255, 65, 65, 0.13)' : 'rgba(151, 168, 30, 0.16)',
                        color: status === 'error' ? '#ff8e8e' : 'var(--main-color-two)',
                    }}
                >
                    {status === 'error' ? '!' : 'OK'}
                </div> */}

                <h1
                    style={{
                        margin: 0,
                        fontSize: 'clamp(28px, 4vw, 42px)',
                        lineHeight: 1.1,
                        color: '#f4f6f8',
                        fontWeight: 800,
                        letterSpacing: '0.02em',
                    }}
                >
                    {heading}
                </h1>

                <p
                    style={{
                        margin: '16px auto 0',
                        maxWidth: '520px',
                        color: '#cfd3d9',
                        fontSize: '17px',
                        lineHeight: 1.6,
                    }}
                >
                    {message}
                </p>

                {email && (
                    <p
                        style={{
                            marginTop: '14px',
                            color: 'rgba(255, 255, 255, 0.62)',
                            fontSize: '14px',
                            wordBreak: 'break-word',
                        }}
                    >
                        {email}
                    </p>
                )}

                <div style={{ marginTop: '26px', display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
                    {shouldShowResubscribe ? (
                        <button
                            type="button"
                            onClick={handleResubscribe}
                            disabled={isResubscribing}
                            className="btn"
                            style={{
                                padding: '12px 20px',
                                borderRadius: '12px',
                                border: 'none',
                                background: 'linear-gradient(100deg, var(--main-color-one) 0%, #ff9f44 100%)',
                                color: '#ffffff',
                                fontWeight: 700,
                                fontSize: '15px',
                                boxShadow: '0 10px 24px rgba(255, 129, 14, 0.34)',
                            }}
                        >
                            {isResubscribing ? 'Re-subscribing...' : 'Resubscribe'}
                        </button>
                    ) : (
                        <Link
                            to="/"
                            className="btn"
                           
                            style={{
                                padding: '12px 20px',
                                borderRadius: '12px',
                                border: 'none',
                                background: 'linear-gradient(100deg, var(--main-color-one) 0%, #ff9f44 100%)',
                                color: '#ffffff',
                                fontWeight: 700,
                                fontSize: '15px',
                                boxShadow: '0 10px 24px rgba(255, 129, 14, 0.34)',
                            }}
                        >
                            Home to Explore
                        </Link>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Message;
